<td class="pricing-action-buttons-cell">
   <ng-container *ngIf="actions().canApprovePrice && !row().isEditing">
      <a
         href="javascript:void(0);"
         title="Approve price"
         alt="Approve price"
         class="priceManagerIcon"
         (click)="onApprovePriceClick($event)"
         style="margin-right: 10px; vertical-align: -webkit-baseline-middle"
         [ngStyle]="{
            opacity: actions().canApprovePrice && row()?.newPrice > 0 ? '1' : '0',
            'pointer-events': actions().canApprovePrice && row()?.newPrice > 0 ? 'all' : 'none'
         }">
         <span *ngIf="!row().isSaving">
            <i
               class="fa fa-check"
               style="font-size: 16px; color: #01a978"></i>
         </span>
      </a>
      <a
         href="javascript:void(0);"
         title="Reject price"
         alt="Reject price"
         (click)="onRejectPriceClick($event)"
         style="margin-right: 10px; vertical-align: -webkit-baseline-middle"
         [ngStyle]="{
            opacity: actions().canApprovePrice && row()?.newPrice > 0 ? '1' : '0',
            'pointer-events': actions().canApprovePrice && row()?.newPrice > 0 ? 'all' : 'none'
         }">
         <span *ngIf="!row().isSaving">
            <i
               class="fa fa-remove"
               style="font-size: 16px; color: #ed5a68"></i>
         </span>
      </a>
      <span
         *ngIf="row().isSaving"
         class="spinnerSave mr-1"></span>
   </ng-container>
   
   <!-- Do not think we need this, so commenting out for now -->
   <!--<a
      *ngIf="actions().canEditPrice && !row().isEditing"
      class="priceManagerIcon"
      href="javascript:void(0);"
      (click)="toggleEdit($event)"
      [id]="'inner' + row().id"
      style="vertical-align: -webkit-baseline-middle; padding: 6px 3px 6px 6px">
      <i
         class="fa fa-pencil"
         style="font-size: 14px"></i>
   </a>-->

   <!-- FOR PRICING 2.0 -->
   <button
      *ngIf="actions().canRequestPrice"
      class="v-button v-button-sm v-white"
      (click)="toggleEdit($event)"
      [id]="'inner' + row().id">
      <i class="fa fa-comment-dollar requestIcon"></i>
      &nbsp;Request Price
   </button>

   <a
      *ngIf="!row().isEditing && row().approvalStatus === 'Pending'"
      class="pricing-badge"
      href="javascript:void(0);"
      (click)="toggleEdit($event)"
      [id]="'inner' + row().id"
      style="vertical-align: -webkit-baseline-middle">
      <span class="badge activity-badge v-darkgray">
         <i class="fa fa-user-check"></i>
         &nbsp;Requested
      </span>
   </a>

   <a
      class="pricing-badge"
	  *ngIf="!row().isEditing"
      href="javascript:void(0);"
      [id]="'inner' + row().id"
      style="vertical-align: -webkit-baseline-middle">
      @switch (row().approvalStatus) { @case('Approved') {
      <span class="badge activity-badge badge-bg-approved">
         <i class="la la-clipboard-check"></i>
         &nbsp;Approved
      </span>
      } @case ('Rejected') {
      <span class="badge activity-badge badge-bg-rejected">
         <i class="la la-remove"></i>
         &nbsp;Rejected
      </span>
      } @case ('Overridden') {
      <span class="badge activity-badge badge-bg-overridden">
         <i class="fa fa-user-cog"></i>
         &nbsp;Overridden
      </span>
      } @case ('Discussion') {
      <span class="badge activity-badge badge-bg-in-discussion">
         <i class="fa fa-comments-dollar"></i>
         &nbsp;In Discussion
      </span>
      } }
   </a>

   <div
      *ngIf="!row().isEditing"
      class="dropdown dropdown-action"
      style="display: inline-block; vertical-align: -webkit-baseline-middle; width: 25px; margin-left: 2px">
      <a
         href="javascript:void(0);"
         (click)="$event.stopPropagation()"
         class="action-icon dropdown-toggle"
         data-bs-toggle="dropdown"
         aria-expanded="false">
         <i class="material-icons">more_vert</i>
      </a>

      <div
         class="dropdown-menu dropdown-menu-right moreDetailsDrop"
         #dotsToggle
         style="padding: 5px 0px 0px 0px; border: 0px; background: transparent">
         <button
            type="button"
            class="btn btn-primary pricingDetailsButton"
            (click)="onMoreDetailsClick($event)">
            <i class="fa fa-eye"></i>
            More Details
         </button>
      </div>
   </div>

   <span
      *ngIf="!row().isEditing && !!actions().undoAction"
      style="font-size: 12px">
      <br />
      <div style="height: 4px"></div>
      <a
         href="javascript:void(0);"
         (click)="onUndoClick($event)">
         <span *ngIf="!row().isSaving">
            <i class="fa fa-undo"></i>
            &nbsp;Reset / Undo
         </span>
         <span
            *ngIf="row().isSaving"
            class="spinnerSave"></span>
      </a>
   </span>

   <a
      *ngIf="row().isEditing"
      class="priceManagerIcon"
      href="javascript:void(0);"
      (click)="$event.stopPropagation(); onSave()"
      style="margin-right: 10px"
      title="Save price"
      alt="Save price">
      <span *ngIf="!row()?.isSaving">
         <i
            class="fa fa-check"
            style="font-size: 16px"></i>
      </span>
      <span
         *ngIf="row()?.isSaving"
         class="spinnerSave"></span>
   </a>

   <a
      href="javascript:void(0);"
      *ngIf="row().isEditing"
      (click)="onCancelClick($event)"
      style="margin-right: 5px; color: #7d7d7d"
      title="Cancel"
      alt="Cancel">
      &nbsp;
      <i
         class="fa fa-remove"
         style="font-size: 16px"></i>
   </a>
</td>
